import { Component, inject } from '@angular/core';
import { StandardPageLayoutComponent } from '@layouts/pages/standard-page-layout/standard-page-layout.component';
import { EditionPageService } from './edition-page.service';
import { Observable } from 'rxjs';
import { EditionPage } from '@features/models/events/editions/edition-page';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { OutlineStarIconComponent } from '@shared/icons/outline-star-icon.component';
import { UserService } from '@core/services/user.service';

@Component({
  selector: 'app-edition-page',
  imports: [StandardPageLayoutComponent, AsyncPipe, RouterLink, OutlineStarIconComponent],
  templateUrl: './edition-page.component.html',
  providers: [EditionPageService]
})
export class EditionPageComponent {

  private _editionPageService = inject(EditionPageService);
  public _userService = inject(UserService);
  private _route = inject(ActivatedRoute);

  public editionPage$?: Observable<EditionPage>;

  ngOnInit(): void {
    const editionId = this._route.snapshot.paramMap.get('id');

    if (editionId) {
      this.editionPage$ = this._editionPageService.getEditionData(editionId);
    }
  }

  public formatFromToDate(from?: string, to?: string): string {
      let fromToLabel: string | null = null;
  
      if (from) {
        var fromDate = new Date(from);
        const fromDay = fromDate.getDate();
        const fromMonth = fromDate.toLocaleString('default', { month: 'short' });
        fromToLabel = `${fromDay} ${fromMonth}`;
      }
  
      if (to) {
        var toDate = new Date(to);
        const toDay = toDate.getDate();
        const toMonth = toDate.toLocaleString('default', { month: 'short' });
  
        if ((fromToLabel?.length ?? 0) > 0) {
          fromToLabel = `${fromToLabel} to ${toDay} ${toMonth}`;
        } else {
          fromToLabel = `${toDay} ${toMonth}`;
        }
      }
  
      return fromToLabel ?? 'Dates to be announced';
    }

    public formatDate(input?: string): string {
      let dateLabel: string | null = null;
  
      if (input) {
        var inputDate = new Date(input);
        const inputDay = inputDate.getDate();
        const inputMonth = inputDate.toLocaleString('default', { month: 'short' });
        dateLabel = `${inputDay} ${inputMonth}`;
      }
  
      return dateLabel ?? 'Date to be announced';
    }

}
